import { borderRadius8 } from 'glints-aries/es/@next/utilities/borderRadius';
import { Red, Yellow } from 'glints-aries/es/@next/utilities/colors';
import {
  space4,
  space8,
  space12,
} from 'glints-aries/es/@next/utilities/spacing';
import styled from 'styled-components';

export const StyledBanner = styled.div`
  display: flex;
  gap: ${space8};
  padding: ${space8} 20px;
  width: 100%;
  background-color: ${Yellow.S75};
  border-radius: ${borderRadius8};
  align-items: center;

  &[data-branding-update='true'] {
    background: linear-gradient(
      90deg,
      rgb(255, 243, 244) 0%,
      rgb(255, 243, 232) 100%
    );
  }
`;

export const NavbarBannerStyle = styled(StyledBanner)`
  padding: ${space4} ${space12};
`;

export const TopCutoutBannerStyle = styled(StyledBanner)`
  width: fit-content;
  padding: ${space4} ${space12};
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
`;

export const VipModalBannerStyle = styled(StyledBanner)`
  padding: ${space8} ${space12};
  border-radius: 8px;
  border: 1px solid ${Yellow.S75};
  background: linear-gradient(
      0deg,
      rgba(255, 242, 64, 0.1) 0%,
      rgba(255, 242, 64, 0.1) 100%
    ),
    #fff;

  span {
    color: ${Red.B93};
  }
`;
